import * as React from "react";
import CallToAction from "../../templates/callToAction";
import FeatureItemLeftSide from "../../templates/featureItemLeft";
import FeatureItemRightSide from "../../templates/featureItemRightSide";
import FeaturesHeroSection from "../../templates/featuresHeroSection";
import FooterSection from "../../templates/footer";
import NavBar from "../../templates/navbar";
import TestimonialsSection from "../../templates/testomonials";
import HeroImage from "./../../images/features-popup/hero-img.png";
import ReportsImage from "./../../images/features-popup/popup-reports.png";
import SignupFormImage from "./../../images/features-popup/signup-forms.png";
import SegmentsImage from "./../../images/features-popup/specific-segments.png";
import WhenWhereImage from "./../../images/features-popup/when-where.png";
import { Helmet } from "react-helmet";

// Import icon images
import ThemeIcon from "./../../images/icons/theme.svg";
import PopupBuilderIcon from "./../../images/icons/popup-builder.svg";
import CustomerAttributeIcon from "./../../images/icons/customer-attribute.svg";
import DeviceProfileIcon from "./../../images/icons/device-profile.svg";
import DisplayRulesIcon from "./../../images/icons/display-rules.svg";
import GDPRCompliantIcon from "./../../images/icons/gdpr-compliant.svg";

const info = {
  allFeatures: [
    {
      // icon: LightningBoltIcon,
      title: "Pre-built Themes & Templates",
      image: ThemeIcon,
      description:
        "Pick any one of pre-built themes, and modify it according to your branding needs.",
    },
    {
      // icon: ScaleIcon,
      title: "Popup Builder",
      image: PopupBuilderIcon,
      description:
        "Easily create beautiful and branded forms with drag & drop editor. Customise form input, buttons, thank you section and more.",
    },
    {
      // icon: ScaleIcon,
      title: "Targeted Segments",
      image: CustomerAttributeIcon,
      description:
        "Use segments to show popups to only customers who haven’t purchased lately, or hide new signup forms from customers who recently purchased.",
    },
    {
      // icon: ScaleIcon,
      title: "Custom Display Rules",
      image: DisplayRulesIcon,
      description:
        "Whether you’re collecting emails, phone numbers, or both, Klaviyo helps you stay compliant.",
    },
    {
      // icon: GlobeAltIcon,
      title: "Mobile Optimized",
      image: DeviceProfileIcon,
      description:
        "Forms are mobile responsive and provide the best views to your mobile visitors.",
    },
    {
      //// icon: ScaleIcon,
      title: "GDPR and TCPA compliant",
      image: GDPRCompliantIcon,
      description:
        "Growlytics makes sure you stay compliant whether you’re collecting emails, phone numbers, or both.",
    },
  ],
  signupFormFeatures: [
    {
      title: "Forms in popup",
    },
    {
      title: "Forms in flout boxes",
    },
    {
      title: "Inline forms",
    },
  ],
  whenWhereList: [
    {
      title: "On All or specific pages",
    },
    {
      title: "Show at page load or exit or at cutomer action",
    },
    {
      title: "Show/hide on mobile and desktop",
    },
  ],
  targetedForms: [
    { title: "Restrict to first-time or repeat visitors." },
    { title: "Restrict to segments or past behaviours." },
    { title: "Restrict based on customer attributes." },
  ],
  reportingFeatures: [
    { title: "Analyze impressions and conversions." },
    { title: "Followup converted visitors with automation." },
    { title: "Sync subscribers with other platforms." },
  ],
};
// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta
          name="description"
          content="Convert visitors to contacts using Growlytics’s on-site popups, forms and start messaging them manually or with automation."
        />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Forms & Popups</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar></NavBar>

      {/* Hero Section */}
      <FeaturesHeroSection
        image={HeroImage}
        title1="Convert visitors to contacts with"
        title2="popups & layouts"
        description="Convert more customers from your existing traffic using Growlytics’s on-site popups, forms and start messaging them manually or with automation."
        paddingRight="pr-0 md:pr-10"
      ></FeaturesHeroSection>

      {/* Signup Forms */}
      <FeatureItemLeftSide
        features={info.signupFormFeatures}
        image={SignupFormImage}
        badge="Signup Forms"
        title="Grow your customer base with popups & flyouts"
        description=" Onborarding new customers or retaining loyal customers? Choose
        use case specific responsive on-site displays. No coding
        required!"
      ></FeatureItemLeftSide>

      {/* When & where */}
      <FeatureItemRightSide
        features={info.whenWhereList}
        image={WhenWhereImage}
        badge="When & Where"
        title="Show messages at the right time when customers are engaged."
        description="Use Triggers & filters like on which all pages to show the
        form and when to show the form like at page load or as exit
        intent or when user performs a particular action."
      ></FeatureItemRightSide>

      {/* Target Segment with Poups */}
      <FeatureItemLeftSide
        features={info.targetedForms}
        image={SegmentsImage}
        badge="Only Targeted Customers"
        title="Show messages to segment customers"
        description="Treat visitors differently with targeted forms. Show discounts
        and offers to customers that haven’t purchased recently, or
        don't show discount pops to loyal customers. Use advanced
        segments to show popups to only specific customers."
      ></FeatureItemLeftSide>

      {/* Reports */}
      <FeatureItemRightSide
        features={info.reportingFeatures}
        image={ReportsImage}
        badge="Analytics & Reporting"
        title="Analyze & optimize conversions"
        description="Get detailed performance report of your popup forms. Analyze
        the views, click rate, conversion rate, and close rate. "
      ></FeatureItemRightSide>

      {/* All Features Section */}
      <div className="relative sm:mt-5 md:mt-20 bg-gray-50 pt-20 pb-20 sm:pb-50">
        <div className="text-center mb-5">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-badgecolor text-badgetextcolor">
            Other Popup Features
          </span>
        </div>
        <p className="mt-2 mb-20 text-3xl px-5 font-extrabold text-gray-900 tracking-tight sm:text-4xl text-center">
          Create personalized experience, for every customer.
        </p>
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 mt-15">
          <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8">
            {info.allFeatures.map((feature) => (
              <div key={feature.title} className="sm:text-center">
                <dt>
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary-600 text-white m-auto md:ml-0">
                    {/* <feature.icon className="h-6 w-6" aria-hidden="true" /> */}
                    <img
                      src={feature.image}
                      className="h-10 w-10 bg-primary"
                      aria-hidden="true"
                    />
                  </div>
                  <p className="mt-5 text-lg leading-6 font-medium text-gray-900 text-center md:text-left">
                    {feature.title}
                  </p>
                </dt>
                <dd className="mt-2 text-base text-gray-500 text-center md:text-left">
                  {feature.description}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      {/* Testimonials Section */}
      <TestimonialsSection></TestimonialsSection>

      {/* Call To Action */}
      <CallToAction></CallToAction>

      {/* Add Footer */}
      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
